import React, { Component } from 'react'
import { ModalWrapper } from './modalWrapper'

export type Callback<T = void> = (...args: any) => T

import { ConversationMeta } from './types'

export interface Props {
  hideModal: Callback
  submitResolveConv: Callback
  currentConv: ConversationMeta
}
export class ResolveConvModal extends Component<Props> {
  static displayName = 'Resolve Conv Modal'

  render() {
    const { hideModal, submitResolveConv, currentConv } = this.props
    const currentConvId = currentConv.conversation.id

    return (
      <ModalWrapper
        title="Are you sure you want to resolve this conversation?"
        width="550px"
        height="305px"
        {...this.props}
      >
        <p>
          Resolving this issue will remove this conversation from your
          Chatterbox and hide it from the Message Center. You can re-open the
          conversation from this user's AdminWeb profile.
        </p>
        <div className="modal__buttons">
          <button
            className="button button--secondary button--inline"
            type="button"
            onClick={hideModal}
          >
            No
          </button>
          <button
            className="button button--primary"
            type="button"
            onClick={() => submitResolveConv(currentConvId)}
          >
            Yes
          </button>
        </div>
      </ModalWrapper>
    )
  }
}
